enum ReceptionStatus {
  DONE = "done",
  TODO = "todo",
}

export default ReceptionStatus;
